import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg2534 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 300,
	height: 281,
	viewBox: "0 0 300 281",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.896 162.965C-14.5972 110.617 12.6136 50.9008 68.5995 29.6196L126.638 7.56399C182.661 -13.7297 246.324 11.4793 268.805 63.8019L292.105 118.035C314.598 170.389 287.381 230.099 231.395 251.38L173.357 273.436C117.34 294.73 53.677 269.521 31.1963 217.204L7.896 162.965Z",
			fill: "url(#paint0_linear_29_1016)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 252H33.5",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.5 252H61",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.5 252H233",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M248 252H272",
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 87,
			y: 45.9999,
			width: 126,
			height: 206,
			rx: 9,
			stroke: "black",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.711 35.1621C136.824 33.4942 138.697 32.4926 140.702 32.4926L159.269 32.4926C161.274 32.4926 163.146 33.4942 164.259 35.1621L166.252 38.1474C168.912 42.1346 166.054 47.4779 161.261 47.4779L138.71 47.4779C133.916 47.4779 131.058 42.1346 133.719 38.1474L135.711 35.1621Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98,
			y: 199,
			width: 112,
			height: 50,
			rx: 6,
			fill: "url(#paint1_linear_29_1016)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 123,
			cy: 118,
			r: 13,
			fill: "url(#paint2_linear_29_1016)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 177,
			cy: 119,
			r: 13,
			fill: "url(#paint3_linear_29_1016)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.969 94.7659C124.504 94.1427 121.418 94.1827 118.241 95.034C115.064 95.8854 112.372 97.3933 110.548 99.1659",
			stroke: "black",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M189.452 99.1659C187.628 97.3933 184.936 95.8854 181.759 95.0341C178.582 94.1827 175.496 94.1427 173.031 94.766",
			stroke: "black",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 113.228,
			y1: 115,
			x2: 133.228,
			y2: 115,
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 128,
			y1: 153,
			x2: 172,
			y2: 153,
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 167.228,
			y1: 115,
			x2: 187.228,
			y2: 115,
			stroke: "black",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 128.228,
			cy: 118,
			r: 4,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 181.228,
			cy: 118,
			r: 4,
			fill: "black"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_29_1016",
				x1: 150,
				y1: 0,
				x2: 150,
				y2: 281,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#EDEDED" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EDEDED",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_29_1016",
				x1: 154,
				y1: 199,
				x2: 154,
				y2: 249,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#F39519" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EA6907"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_29_1016",
				x1: 123,
				y1: 105,
				x2: 123,
				y2: 131,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#F7C38B",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F7C38B",
					stopOpacity: .75
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_29_1016",
				x1: 177,
				y1: 106,
				x2: 177,
				y2: 132,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#F7C38B",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F7C38B",
					stopOpacity: .75
				})]
			})
		] })
	]
});
export default Svg2534;
